import React, {Component} from 'react';
import {window} from 'ssr-window';
import DOMUtils from '@spothero/utils/dom';
import Button from '@spothero/ui/button';
import EnvironmentUtils from '@spothero/utils/environment';
import SearchControls from 'search/controls/SearchControls';
import Icon from 'common/icon/Icon';

export default class NotFound extends Component {
    constructor(props) {
        super(props);

        this._isMobile = EnvironmentUtils.isMobileDevice();
    }

    componentDidMount() {
        DOMUtils.addClass('body', 'error-page');
    }

    componentWillUnmount() {
        DOMUtils.removeClass('body', 'error-page');
    }

    _onFindParkingClick = evt => {
        window.location = '/parking-near-me/';
    }

    render() {
        return (
            <div className="NotFound">
                <div className="NotFound-hero">
                    <h1 className="NotFound-error-code">404</h1>
                    <div className="NotFound-content-wrap">
                        <div className="NotFound-content">
                            <h2 className="NotFound-error-message">
                                Looks like you made a wrong turn.<br />
                                This page doesn&apos;t exist, but you can still get parking below.
                            </h2>
                            {(this._isMobile)
                                ? (
                                    <Button
                                        color="secondary"
                                        iconPosition="left"
                                        onClick={this._onFindParkingClick}
                                    >
                                        <Icon name="search" />
                                        Find parking
                                    </Button>
                                ) : (
                                    <SearchControls
                                        showDateTimes={false}
                                        showFindParkingButton
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
